import { DialogInfo } from "../models/DialogInfo";

export const getDialogInfo = (action: string): DialogInfo => {
    let dialog: DialogInfo;
    switch (action) {
        case "reset":
            dialog = {
                title: "Reset Cache",
                message: "Are you sure you want to reset cache?",
                actions: {
                    confirm: {
                        show: true,
                        label: "Reset",
                        color: "warn",
                        icon: "close",
                    },
                    cancel: {
                        show: true,
                        label: "Cancel",
                        icon: "not_interested",
                    },
                },
                actionType: "YesAndNo",
            };
            break;

        case "remove":
            dialog = {
                title: "Remove",
                message: "Are you sure you want to remove?",
                actions: {
                    confirm: {
                        show: true,
                        label: "Remove",
                        color: "warn",
                        icon: "close",
                    },
                    cancel: {
                        show: true,
                        label: "Cancel",
                        icon: "not_interested",
                    },
                },
                actionType: "YesAndNo",
            };
            break;
        case "remove-all-delegations":
            dialog = {
                title: "Remove all delegations",
                message: "Are you sure you want to remove all delegations?",
                actions: {
                    confirm: {
                        show: true,
                        label: "Remove",
                        color: "warn",
                        icon: "close",
                    },
                    cancel: {
                        show: true,
                        label: "Cancel",
                        icon: "not_interested",
                    },
                },
                actionType: "YesAndNo",
            };
            break;
        case "assign-active-task":
            dialog = {
                title: "Assign all active tasks",
                message: "Are you sure you want to assign all active tasks?",
                actions: {
                    confirm: {
                        show: true,
                        label: "Yes",
                        color: "primary",
                        icon: "check",
                    },
                    cancel: {
                        show: true,
                        label: "No",
                        icon: "not_interested",
                    },
                },
                actionType: "YesAndNo",
            };
            break;

        case "restore":
            dialog = {
                title: "Restore",
                message: "Are you sure you want to restore this form version?",
                actions: {
                    confirm: {
                        show: true,
                        label: "Yes",
                        color: "primary",
                        icon: "check",
                    },
                    cancel: {
                        show: true,
                        label: "No",
                        icon: "not_interested",
                    },
                },
                actionType: "YesAndNo",
            };
            break;
    }
    return dialog;
};
